export default __webpack_public_path__ + "static/media/spinner.7db2bb37.gif";